export default {
  main: '#000000',
  secondary: '#00DB07',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
